
import Bitrix24Disk from './Bitrix24Disk';

export default class FileUploader {
}

FileUploader.getFilesList = function (fileInputs) {
  const filesList = {};
  let filesCounter = 0;

  if (fileInputs.length > 0) {
    Array.prototype.forEach.call(fileInputs, (input, i) => {
      const { files } = input;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          filesList[`f${filesCounter}`] = {};
          filesList[`f${filesCounter}`].name = files[i].name;
          filesList[`f${filesCounter}`].reader = new FileReader();
          filesList[`f${filesCounter}`].reader.readAsDataURL(files[i]);
          filesCounter++;
        }
      }
    });
  }

  return filesList;
};

FileUploader.uploadToDisk = function (diskPath, fileInputs) {
  return new Promise((resolve, reject) => {
    const uploadedFileIDs = [];
    const filesList = this.getFilesList(fileInputs);

    if (Object.keys(filesList).length > 0) {
      const storageLoaded = Bitrix24Disk.initStorage();

      storageLoaded.then(() => {
        const pathCreated = Bitrix24Disk.findOrCreatePath(diskPath);

        pathCreated.then((folder) => {
          Object.keys(filesList).forEach((key) => {
            const file = filesList[key];
            const fileUploaded = Bitrix24Disk.uploadToFolder(
              folder,
              file.name,
              file.reader,
            );

            fileUploaded.then((uploadedFile) => {
              delete filesList[key];
              uploadedFileIDs.push(uploadedFile.ID);

              if (Object.keys(filesList).length === 0) {
                resolve(uploadedFileIDs);
              }
            });

            fileUploaded.catch((error) => {
              reject(error);
            });
          });
        });

        pathCreated.catch((error) => {
          reject(error);
        });
      });

      storageLoaded.catch((error) => {
        reject(error);
      });
    } else {
      resolve(uploadedFileIDs);
    }
  });
};
